import { render } from "./resultScan.vue?vue&type=template&id=4bd08012"
import script from "./resultScan.vue?vue&type=script&lang=js"
export * from "./resultScan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__